/**
 * Copyright © 2026 Adnuntius AS.
 */
import {AdnListHelperService} from '../../common/controller/list-helper.service';
import {ChangeDetectorRef, Component, Inject, NgZone, OnChanges} from '@angular/core';
import {deferMarkForCheck} from '../../common/util/defer-mark-for-check';
import template from './layout-include-edit-page.component.html';
import {AppEventBusService} from '../../common/events/app-event-bus.service';

import {AdminResourceEditPageBase} from '../../common/controller/admin-resource-edit-page-base';
import {LayoutResource} from '../../../components/api/resources/resource/layout.resource';
import {LocalNetworkProfile} from '../../../components/session/local-network-profile';
import {UserProfileSaverService} from '../../../components/session/user-profile-saver.service';

@Component({
  standalone: false,
  selector: 'adn-layout-include-edit-page',
  template
})
export class LayoutIncludeEditPageComponent extends AdminResourceEditPageBase implements OnChanges {
  showLayoutDetail = false;
  items: any[] = [];
  /** Snapshot — list-helper replaces items on this host mid-CD (NG0100). */
  displayItems: any[] = [];
  hasItems = false;
  displayTotalCount = 0;
  query: any;
  totalCount = 0;
  makeQuery: (() => void) | undefined;
  setMoreParams: ((params: any) => void) | undefined;

  readonly layoutSortColumns = ['name', 'description', 'layoutType', 'layoutCategory'];

  private listInitialized = false;

  constructor(
    eventBus: AppEventBusService,
    @Inject(UserProfileSaverService) UserProfileSaver: any,
    @Inject(LocalNetworkProfile) LocalNetworkProfile: any,
    private adnListHelper: AdnListHelperService,
    private cdr: ChangeDetectorRef,
    @Inject(LayoutResource) private Layout: any,
    ngZone: NgZone
  ) {
    super(eventBus, UserProfileSaver, LocalNetworkProfile, ngZone);
  }

  ngOnChanges(): void {
    super.ngOnChanges();
    if (this.model && !this.isNew && !this.listInitialized) {
      this.listInitialized = true;
      this.adnListHelper.setUpBasicList(this, this.Layout, 'layoutsUsingLayoutInclude', {
        moreParams: {layoutInclude: this.model.id},
        noInitQuery: true,
        afterFill: () => this.snapshotLayouts()
      });
      this.makeQuery?.();
    }
  }

  protected afterInitAfterSave(): void {
    if (!this.isNew) {
      if (!this.listInitialized) {
        this.listInitialized = true;
        this.adnListHelper.setUpBasicList(this, this.Layout, 'layoutsUsingLayoutInclude', {
          moreParams: {layoutInclude: this.model.id},
          noInitQuery: true,
          afterFill: () => {
            this.snapshotLayouts();
          }
        });
      }
      if (!this.query) {
        this.makeQuery?.();
      }
    }
  }

  private snapshotLayouts(): void {
    deferMarkForCheck(this.cdr, () => {
      this.displayItems = (this.items || []).slice();
      this.hasItems = this.displayItems.length > 0;
      this.displayTotalCount = this.totalCount || 0;
    });
  }
}
